export default __webpack_public_path__ + "static/media/Classroom_3_2.9ec67b21.png";